export default {

	init() {
		console.log('init filters...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
		// Floating labels
		$('.filter.animated-labels input').on('focus', function(){
			$(this).closest('.filter').addClass('focused');
		});

		$('.filter.animated-labels input').on('blur', function(){
			if(!$(this).val()) $(this).closest('.filter').removeClass('focused');
		});

		$('.filter.animated-labels input').each(function(){
			if($(this).val()) $(this).closest('.filter').addClass('focused');
		});

		// Clear input
		$('.filter [data-js="clear-input"]').on('click', function(e) {
			e.preventDefault();
			Filters.handleClearInput(this);
		});

		// Toggle checkboxes
		$('.filter-row [data-js="checkbox-toggle"]').on('click', function(e) {
			Filters.handleCheckboxesToggle(this);
		});
		Filters.initCheckboxesToggle();

		// Clear filters
		$('.filters-active .is-btn-close').on('click', function(e) {
			e.preventDefault();
			Filters.handleClearFilter(this);
		});

		$('.filters-clear .is-btn-clear').on('click', function(e) {
			e.preventDefault();
			Filters.handleClearAllFilters(this);
		});

		// Load more
		$('#content').on('click', '[data-js="loadmore"]', Filters.handleLoadMore);

		// Region filter
		Filters.initMap();

		// Checkbox totals
		Filters.updateFilterCounts();

		// Dropdown listener
		$('.filter.filter-dropdown').each(function(index, element) {
			element.addEventListener('close.dropdown', function(e) {
				Filters.updateFilterCounts();
			});
		});
	},

	initMap() {
		let $container = $('.location-map');
		let regions = '#West, #Midwest, #Northeast, #Southeast, #Southwest';
		let activeId = $container.attr('data-active');

		Filters.ACTIVE_REGION = activeId;

		$('#content')
		.on('mouseenter', regions, function(e)  {
			let currentId = $(this).attr('id');
			$container.attr('data-active', currentId);
		})
		.on('mouseleave', regions, function(e) {
			$container.attr('data-active', Filters.ACTIVE_REGION);
		})
		.on('click', regions, function(e) {
			e.preventDefault();
			Filters.handleRegionChange(this);
		});
	},

	handleRegionChange(elem) {
		let $elem = $(elem);
		let currentId = $elem.attr('id');
		let $container = $('.location-map');
		let $form = $container.closest('form');

		Filters.ACTIVE_REGION = currentId;
		$container.attr('data-active', currentId);

		let $target = $('#region_search--'+currentId.toLowerCase());

		if(!$target.length) {
			return;
		}

		$target.prop('checked', true);
		$form.trigger('submit');
	},

	handleClearInput(elem) {
		let $parent = $(elem).closest('.filter');
		let $input = $parent.find('input');
		if ($input.length) {
			$parent.removeClass('.focused');
			$input.val('').trigger('blur');
		}
	},

	handleCheckboxesToggle(elem) {
		let $toggle = $(elem);
		let $parent = $toggle.closest('.filter-row');
		let $checkboxes = $parent.find('input[type="checkbox"]');
		let isActive = ($toggle.attr('data-js-state') === 'checked') ? true : false;

		if ($checkboxes.length) {
			$checkboxes.each(function(index, elem) {
				$(elem).prop('checked', !isActive);
			});
			$toggle.attr('data-js-state', (isActive ? 'unchecked' : 'checked'));
		}
	},

	initCheckboxesToggle() {
		let $toggles = $('[data-js="checkbox-toggle"]');

		$toggles.each(function(index, element) {
			let $toggle = $(this);
			let $parent = $toggle.closest('.filter-row');
			let $checkboxes = $parent.find('input[type="checkbox"]');
			let $checkboxesChecked = $parent.find('input[type="checkbox"]:checked');

			if($checkboxes.length == $checkboxesChecked.length) {
				$toggle.attr('data-js-state', 'checked');
			}
		});
	},

	updateFilterCounts() {
		let $filters = $('.filter.filter-dropdown');

		$filters.each(function(index, element) {
			let $filter = $(this);
			let $suffix = $filter.find('.filter-suffix');
			let $checkboxes = $filter.find('input[type="checkbox"]:checked');

			if (!$suffix.length) {
				return true;
			}

			if ($checkboxes.length) {
				$suffix.text('('+$checkboxes.length+')');
			} else {
				$suffix.text('');
			}
		});
	},

	handleClearFilter(elem) {
		let target = $(elem).attr('href');

		if (target) {
			target = target.replace('clear--', '');
		}

		let $target = $(target);

		if (!$target.length) {
			return;
		}

		let $form = $target.closest('form');
		let inputType = $target.attr('type');

		if (inputType == 'checkbox' || inputType == 'radio') {
			console.log('check', inputType);
			$target.prop('checked', false);
		}

		if (inputType == 'text' || inputType == 'hidden') {
			console.log('text', inputType);
			$target.val('');
		}

		$form.trigger('submit');
	},

	handleClearAllFilters(elem) {
		// Just follow link for now
		location.href = elem.getAttribute('href');
	},

	handleLoadMore(e) {
		e.preventDefault();

		let $button = $(this);
		let $container = $('#results');
		let url = $button.attr('href');

		$button.text('Loading...').addClass('disabled').on('click', function() { return false; });

		$.get(url, function(data) {
			let $data = $(data);

			$container.append($data.find('#results').contents());
			$container.next('#pager').replaceWith($data.find('#pager'));
		});
	},

}